<template>
  <div class="file-video">
    <div class="video-view" :style="{ backgroundImage: bgImg }">
      <video style="width: 100%; height: 100%; object-fit: fill" :src="src" controls></video>
    </div>
  </div>
</template>

<script>
import {DomainService} from '@/libs'

export default{
  props: {
    src: { default: '' }
  },
  data() {
    return {
      bgImg: `url(${DomainService.PublicPath}resource/images/background/mac.png)`
    }
  }
}
</script>

<style lang="less" scoped>
  .file-video{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .video-view{
    width: 750px;
    height: 452px;
    background-size: 100% 100%;
    padding: 75px 81px 48px 83px;
    margin-top: -40px;
    video{
      outline: -webkit-focus-ring-color auto 0;
    }
  }
</style>
